import { styled } from "@mui/material/styles";
import { Box, Text } from "designSystem/index";
import { useCompareStore } from "csi/page/ComparePageStore";
import { observer } from "mobx-react-lite";
import React, { FunctionComponent } from "react";

const PREFIX = "ChipState";

const classes = {
	root: `${PREFIX}root`,
};

const StyledBox = styled(Box)((
	{
		theme,
	},
) => ({
	[`& .${classes.root}`]: {
		border: "1px solid",
		borderRadius: 30,
		padding: "1px 10px",
	},
}));

interface ChipStateProps {
	/** color class to use with this state header */
	className: string;

	/** indicate compare menu or current menu */
	isCompareMenu: boolean;

	/** state label */
	label: string;
}

export const ChipState: FunctionComponent<ChipStateProps> = observer((props) => {
	const { root } = classes;

	const {
		className,
		isCompareMenu,
		label,
	} = props;

	const {
		compareNode,
		compareRevisionNode,
		comparePDF,
		currentPDF,
		currentNode,
		currentRevisionNode,
		openComparePDF,
		openCurrentPDF,
	} = useCompareStore();

	let bomNode = currentNode;
	let revisionNode = currentRevisionNode;
	let pdf;
	if (isCompareMenu) {
		revisionNode = compareRevisionNode;
		bomNode = compareNode;
		pdf = comparePDF;
	} else {
		pdf = currentPDF;
	}



	return (
		<StyledBox
			className="csi-breadcrumb-left"
			style={{
				// need to override these properties on csi-breadcrumb-left
				display: "inherit",
				flexGrow: "unset",
				flexShrink: "unset",
				overflow: "visible",
			}}
		>
			<Box className={`${className} ${root}`}>
				{pdf && (
					<span
						className="far fa-fw fa-file-pdf"
						onClick={isCompareMenu ? openComparePDF : openCurrentPDF}
					/>
				)}
				<Text semiBold text={label} />
			</Box>
		</StyledBox>
	);
});

export default ChipState;